import {useCallback} from 'react';
import {EventAction, EventCategory, EventContextType, EventLabel, EventNames} from 'modules/google-analytics/constants';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';

import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';

export const useFiltersGtag = () => {
    const {eventLocation} = useGtagEventLocation();

    return useCallback(
        (
            eventContent?: string,
            eventAction = EventAction.AddFilter,
            eventContext = EventContextType.FilterLeftSide,
            eventLabel?: string,
        ) => {
            let dataLayerList: Record<any, any> = {
                event: EventNames.OWOX,
                eventCategory: EventCategory.Interactions,
                eventAction,
                eventLabel: eventLabel || EventLabel.Filter,
                eventLocation,
            };

            if (eventAction !== EventAction.RemoveAllFilters) {
                dataLayerList = {
                    ...dataLayerList,
                    eventContent,
                    eventContext,
                };
            }

            sendGtagEvent(dataLayerList);
        },
        [eventLocation],
    );
};
